import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  onNavigationClick: (item: string) => void;
  activeItem: string;
};

export const Navigation = ({ onNavigationClick, activeItem }: Props) => {
  return (
    <div className="col max-250 settings-inner-left-menu">
      {/* <div
        className={
          activeItem === 'general-info' ? 'active btn darkGray w100 mb-1 mx-0 px-1' : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
        onClick={() => onNavigationClick('general-info')}
      >
        General info
      </div> */}
      <Link
        to="/settings/administration/general-settings"
        className={
          activeItem === 'generalSettings'
            ? 'active btn darkGray w100 mb-1 mx-0 px-1'
            : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
        onClick={() => onNavigationClick('generalSettings')}
      >
        General settings
      </Link>
      <Link
        to="/settings/administration/annuals-and-periods"
        className={
          activeItem === 'annualsAndPeriods'
            ? 'active btn darkGray w100 mb-1 mx-0 px-1'
            : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
        onClick={() => onNavigationClick('annualsAndPeriods')}
      >
        Annuals &amp; Periods
      </Link>
      <Link
        to="/settings/administration/integrations"
        className={
          activeItem === 'integrations' ? 'active btn darkGray w100 mb-1 mx-0 px-1' : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
        onClick={() => onNavigationClick('integrations')}
      >
        Integrations
      </Link>
      {/* <div
        className={
          activeItem === 'quarters' ? 'active btn darkGray w100 mb-1 mx-0 px-1' : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
        onClick={() => onNavigationClick('quarters')}
      >
        Quarters
      </div>

      <div
        className={
          activeItem === 'annual' ? 'active btn darkGray w100 mb-1 mx-0 px-1' : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
        onClick={() => onNavigationClick('annual')}
      >
        Annual
      </div> */}
    </div>
  );
};
